// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeRedblue = {
  redbluePlatformDataContractInvalid:
    "The RedBlue platform data contract is invalid for {field_name}: {reason}",
  redblueBusinessEventInboxRetryLater:
    "The RedBlue business event is already being processed. Retry the original event later",
  redblueBusinessEventUnexpectedRetryableFailure:
    "The RedBlue business event hit a temporary dependency failure and will retry as the original event",
} as const;
